const BooleanCell = ({ isTrue }) => isTrue ? <i className="fa fa-check text-success"></i> : <i className="fa fa-times text-danger"></i>

export default BooleanCell